module.exports = __webpack_public_path__ + "img/logo-color-lg.09bb81b6.png";